import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { ListPoisRawResponse, PointsOfInterest } from "@/redux/apis/clientPoi/types";
import { baseQueryWithProvider } from "@/redux/baseQuery";

export const providerPoiApi = createApi({
  reducerPath: "providerPoiApi",
  baseQuery: baseQueryWithProvider("location"),
  endpoints: (builder) => ({
    // Provider/known POIs (airports, landmarks). GLOBAL_OVERRIDE rows are vendor overrides, not
    // suggestable places, so they're filtered out — mirrors the mobile poiApi.listProviderPOIs split.
    listProviderPois: builder.query<PointsOfInterest[], void>({
      query: () => ({ url: "/poi", params: { all: true } }),
      transformResponse: (r: ListPoisRawResponse) =>
        (r?._embedded?.items ?? []).filter((poi) => poi.rm_type !== "GLOBAL_OVERRIDE"),
    }),
  }),
});

export const { useListProviderPoisQuery } = providerPoiApi;
